/**
 * SegToggle — сегментированный переключатель режима виджета
 * («План / Факт», «Сумма / Кол-во», FR-4.2/FR-5.2/FR-6.2): ряд кнопок
 * в общей рамке, активная — заливка brand-50.
 */
import { cn } from '../../../lib/cn';

export interface SegOption<V extends string> {
  value: V;
  label: string;
}

interface SegToggleProps<V extends string> {
  options: Array<SegOption<V>>;
  value: V;
  onChange: (value: V) => void;
  ariaLabel: string;
  testId?: string;
}

export const SegToggle = <V extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  testId,
}: SegToggleProps<V>) => (
  <div
    role="group"
    aria-label={ariaLabel}
    data-testid={testId}
    className="inline-flex shrink-0 overflow-hidden rounded-lg border border-surface-border"
  >
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
        className={cn(
          'px-2.5 py-1 text-xs transition-colors',
          value === option.value
            ? 'bg-brand-50 font-semibold text-brand-700'
            : 'text-text-muted hover:bg-surface-muted',
        )}
      >
        {option.label}
      </button>
    ))}
  </div>
);
